import { Component } from "preact";
import Casino, { GamesBrand } from "../../../../services/casino-feed";
import * as I from "../../utils/icons";
import { GameIcon } from "./casino-contents";


export class CasinoSearchPopup extends Component {
	static CASINO_SEARCH_HASH = "#search-game";

	state = {
		open: window.location.hash == CasinoSearchPopup.CASINO_SEARCH_HASH,
		name: "",
		provider: "",
		brand: "",
		games: Casino.flattenSlotList()
	};

	componentWillMount() {
		window.addEventListener("hashchange", (e) => {
			this.setState({
				open: window.location.hash == CasinoSearchPopup.CASINO_SEARCH_HASH,
			});
		});
		Casino.listenChanges(() => {
			this.setState({ games: Casino.flattenSlotList() });
		});
	}

	filterByName(name) {
		this.setState({ name: name });
	}

	filterByProvider(provider) {
		this.setState({ provider: this.state.provider == provider ? "" : provider });
	}

	filterByBrand(provider, brand) {
		const isIdentical = provider + "/" + brand == this.state.provider + "/" + this.state.brand;
		this.setState({
			brand: isIdentical ? "" : brand,
			provider: isIdentical ? "" : provider,
		});
	}

	isSelected(provider, brand) {
		return this.state.provider == provider.id && this.state.brand == brand.id;
	}

	render() {
		if (!this.state.open)
			return null;
		return (
			<div
				class={"fixed inset-0 bg-black/50 z-10 " + (this.state.open ? "" : " hidden")}
				onClick={(e) => (e.target == e.currentTarget ? window.history.back() : null)}
			>
				<div
					id="casino-search-popup"
					class={"flex flex-col rounded overflow-hidden border border-black absolute h-[490px] w-2xl top-[50vh] left-[50vw] -translate-y-1/2 -translate-x-1/2 bg-slate-800 text-white"}
				>
					<div class="border-0 border-b border-black flex h-12 shrink-0 items-center justify-between bg-slate-700 text-base">
						<div class="flex gap-2 px-3 text-slate-400 h-full items-center w-full min-w-0">
							<div class="flex h-full items-center py-3">
								<I.SearchIcon class="h-3" />
							</div>
							<input
								placeholder="Search for a game!"
								class="border-0 text-left h-full grow w-full bg-transparent text-white"
								onInput={(e) => this.filterByName(e.currentTarget.value)} />
						</div>
						<div class="flex h-full items-center justify-center border-l border-slate-600 aspect-square text-slate-400"><I.FilterIcon class="h-6" /></div>
					</div>
					<div class="w-full h-full flex min-h-0 ">
						<div class="overflow-y-auto scrollbar-fancy bg-slate-900 w-[623px]">
							<div class="fn-games-list px-4 py-2 grid grid-cols-5 gap-2">
								{this.state.games &&
									this.state.games
										.filter((p) => (!this.state.provider || p.provider == this.state.provider)
											&& (!this.state.brand || p.category == this.state.brand))
										.filter((g) => g.name.toLowerCase().indexOf(this.state.name.toLowerCase()) >= 0)
										.slice(0, 20)
										.map((game) => <GameIcon game={game} />)}
							</div>
						</div>
						<div class="w-lg max-w-xs w-full scrollbar-fancy overflow-y-auto">
							<div class="fn-filter-1 px-4 py-3">
								<div class="flex items-center justify-start pb-2">
									<div class="">Brands</div>
								</div>
								<div class="flex flex-wrap gap-2">
									{this.state.games &&
										Object.values(Casino.providersList())
											.map((brand: GamesBrand) => (
												<div
													class={"rounded-full grow text-center py-1 px-2 text-white text-xs whitespace-nowrap " +
														(this.isSelected({ id: brand.provider }, { id: brand.id }) ? "bg-slate-600" : "bg-slate-900")}
													onClick={(e) => this.filterByBrand(brand.provider, brand.id)}
												>
													{brand.name}
												</div>
											))}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
